<template>
  <li ref="dropdown" class="dropdown dropdown-notifications">
    <a class="nav-link dropdown-toggle" href="#" @click.prevent="toggleDropdown">
      <i :data-count="total" :class="['icon-notification', !hasUnread ? 'hide-count' : '' ]"></i>
    </a>
    <div class="dropdown-container">
      <div class="dropdown-toolbar" v-if="hasUnread">
        <div v-show="hasUnread" class="dropdown-toolbar-actions">
          <a href="#" @click.prevent="markAllRead">Mark all as read</a>
        </div>
      </div>
      <ul class="dropdown-notification-menu">
        <notification v-for="notification in notifications"
                      :key="notification.id"
                      :notification="notification"
                      @read="markAsRead(notification)" />

        <li v-if="!hasUnread" class="notification notification--empty align-c-hlp">
          You don't have any unread notifications.
        </li>
      </ul>

      <div v-if="hasUnread" class="dropdown-footer align-c-hlp">
        <a href="#" @click.prevent="fetch(null)">View All</a>
      </div>
    </div>
  </li>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'
  import Notification from './Notification'
  export default {
    components: { Notification },
    data: () => ({
      total: 0,
      notifications: []
    }),
    computed: {
      hasUnread() {
        return this.total > 0
      }
    },
    mounted() {
      this.fetch()
      if (window.Echo) {
        this.listen()
      }
      this.initDropdown()
    },
    methods: {
      /**
       * Fetch notifications.
       *
       * @param {Number} limit
       */
      fetch(limit = 5) {
        var that = this;
        axios.get('/api/notifications', { params: { limit } })
          .then(({ data: { total, notifications } }) => {
            that.total = total;
            that.notifications = notifications.map(({ id, data, created }) => {
              return {
                id: id,
                icon: data.icon,
                title: data.title,
                body: data.body,
                created: created,
                action_url: data.action_url
              }
            })
          })
      },
      /**
       * Mark the given notification as read.
       *
       * @param {Object} notification
       */
      markAsRead({ id }) {
        const index = this.notifications.findIndex(n => n.id === id)
        if (index > -1) {
          this.total--
          this.notifications.splice(index, 1)
          axios.patch(`/api/notifications/${id}/read`)
        }
      },
      /**
       * Mark all notifications as read.
       */
      markAllRead() {
        this.total = 0
        this.notifications = []
        axios.post('/api/notifications/mark-all-read')
      },
      /**
       * Listen for Echo push notifications.
       */
      listen() {
        window.Echo.private(`App.Domains.User.User.${window.Laravel.user.id}`)
          .notification(notification => {
            this.total++
            this.notifications.unshift(notification)
          })
          .listen('NotificationRead', ({ notificationId }) => {
            this.total--
            const index = this.notifications.findIndex(n => n.id === notificationId)
            if (index > -1) {
              this.notifications.splice(index, 1)
            }
          })
          .listen('NotificationReadAll', () => {
            this.total = 0
            this.notifications = []
          })
      },
      /**
       * Initialize the notifications dropdown.
       */
      initDropdown() {
        const dropdown = $(this.$refs.dropdown)
        $(document).on('click', (e) => {
          if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0 &&
            !$(e.target).parent().hasClass('notification-mark-read')) {
            dropdown.removeClass('open')
          }
        })
      },
      /**
       * Toggle the notifications dropdown.
       */
      toggleDropdown() {
        $(this.$refs.dropdown).toggleClass('open')
      }
    }
  }
</script>